<template>
    <fieldset :disabled="!isEditing.value">
        <div class="col-auto">
            <label for="function-select" class="col-form-label">Selecionar Função</label>

            <SearchableSelect id="function-select" :items="functionsOptions"
                :initial-selected-item="action.functionName" placeholder="Selecione uma função"
                @item-selected="selectFunction" />
        </div>

        <div v-if="action.function && action.function.templates" class="mt-3">
            <label>Templates Disponíveis</label>
            <SearchableSelect id="function-select-template" :items="templateOptions" placeholder="Selecione um template"
                @item-selected="selectTemplate" />
        </div>

        <div v-if="action.function && action.function.arguments?.length > 0 && action.function?.name != 'message-wa-client'"
            class="mt-3">
            <h5>Parâmetros</h5>
            <div v-for="(arg, index) in action.function.arguments" :key="index" class="col-auto">
                <label :for="arg.name" class="col-form-label">{{ arg.label }}</label>

                <template v-if="arg.type === 'string' && !arg.background">
                    <input type="text" class="form-control" :id="arg.name" v-model="action.parameters[arg.name]" />
                </template>

                <template v-if="arg.type === 'select' && !arg.background">
                    <div class="mb-3">
                        <label for="status" class="form-label">Selecione uma opção:</label>

                        <SearchableSelect :initial-selected-item="action.parameters[arg.name]" :items="arg.options"
                            @item-selected="(value) => action.parameters[arg.name] = value" />
                    </div>
                </template>

                <template v-else-if="arg.type === 'number' && !arg.background">
                    <input type="number" class="form-control" :id="arg.name"
                        v-model.number="action.parameters[arg.name]" />
                </template>

                <template v-else-if="arg.type === 'boolean' && !arg.background">
                    <select class="form-select" :id="arg.name" v-model="action.parameters[arg.name]">
                        <option :value="true">Verdadeiro</option>
                        <option :value="false">Falso</option>
                    </select>
                </template>
            </div>
        </div>
    </fieldset>

    <div v-if="action.function?.name == 'message-wa-client'">
        <WaMessageClient :companyId="this.companyId" :sectionId="sectionId" v-model="action.parameters" />
    </div>

    <br>
    <div class="d-flex gap-1">
    <div @click="copyToClipboard(variable)" class="variables" :style="{background: stringToColor(variable)}" v-for="variable in action.variables" :key="variable">
            {{ variable }}</div>
    </div>

    <div class="mt-3">
        <button v-if="isEditing.value" class="btn btn-success" @click="saveChanges()">Salvar</button>
        <button v-if="action.function" class="btn btn-primary ms-2" @click="executeFunction()">Executar</button>
    </div>

    <div v-if="response" :class="{
        'alert': true,
        'alert-success': response?.success,
        'alert-danger': response?.success === false
    }" style="margin-top: 20px">
        {{ response }}
    </div>
</template>

<script>
import useEditMode from "@/services/EditingService";
import SearchableSelect from "@/components/SearchableSelect.vue";
import { executeFunction } from "../../services/backend/functionService";
import WaMessageClient from "./ActionsForm/WaMessageClient.vue";
import { actionService } from "@/services/backend/ApiService";

export default {
    components: {
        SearchableSelect,
        WaMessageClient
    },
    props: {
        functionsList: {
            type: Object,
            required: true
        },
        actionInit: {
            type: Object,
            required: false,
        },
        modelValue: {
            type: Object,
            required: true,
        },
        companyId: {
            type: Number,
            required: false
        },
        sectionId: {
            type: Number,
            required: false
        }
    },
    emits: ["update:modelValue", "select-function"],
    data() {
        return {
            response: null,
            functionsOptions: [],
            templateOptions: [],
        };
    },
    computed: {
        deep: true,
        action: {
            get() {
                return this.modelValue ?? { isTemplate: false, actions: [] };
            },
            set(value) {
                this.$emit("update:modelValue", value);
            }
        }
    },
    methods: {
        selectFunction(selectedFunction) {
            this.action.function = this.functionsList.find(value => value.name === selectedFunction);
            this.action.functionName = this.action.function.name;

            this.templateOptions =
                this.action.function.templates?.map((template) => ({
                    option: template.name,
                    value: template,
                })) || [];

            this.action.parameters = {};
            this.action.function.arguments?.forEach((arg) => {
                this.action.parameters[arg.name] = "";
            });

            this.$emit("select-function", selectedFunction);
        },
        selectTemplate(selectedTemplate) {
            selectedTemplate.arguments.forEach((arg) => {
                this.action.parameters[arg.name] = arg.value;
            });
        },
        async executeFunction() {
            try {
                this.response = await executeFunction({
                    name: this.action.function.name,
                    args: this.action.parameters
                });
            } catch (error) {
                this.response = error.response.data;
            }
        },
        saveChanges() {
            const body = { ...this.action }
            actionService.update(this.action.id, body)
        },
        copyToClipboard(text) {
            navigator.clipboard.writeText(text);
        },
        stringToColor(str) {
            let hash = 0;

            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }

            let color = "#";
            for (let i = 0; i < 3; i++) {
                const value = (hash >> (i * 8)) & 0xFF;
                color += value.toString(16).padStart(2, '0');
            }

            return color;
        }
    },
    setup() {
        const isEditing = useEditMode();
        return { isEditing };
    },
    watch: {
        functionsList: {
            handler(newList) {
                if (!newList.length) return

                this.functionsOptions = newList.map((func) => ({
                    option: func.label,
                    value: func.name,
                }));

                if (this.action.functionName) {
                    const parameters = this.action.parameters;

                    this.selectFunction(
                        this.action.functionName
                    )

                    this.action.parameters = parameters;
                }
            },
            immediate: true
        }
    }
};
</script>

<style scoped>
.variables {
    cursor: pointer;
    background-color: rgb(33, 168, 212);
    border-radius: 10px;
    padding: 5px 20px;
    width: fit-content;
    color: white;
}
</style>
